module.exports = __webpack_public_path__ + "media/images/banners/registration-eeaa359296fbd4e71964ec611bf13d1e.png";